import {
  GET_MATERIAL,
  GET_MATERIAL_SUCCESS,
  GET_MATERIAL_FAIL,
  SAVE_MATERIAL,
  SAVE_MATERIAL_SUCCESS,
  SAVE_MATERIAL_FAIL,
  UPDATE_MATERIAL,
  UPDATE_MATERIAL_SUCCESS,
  UPDATE_MATERIAL_FAIL,
  DELETE_MATERIAL,
  DELETE_MATERIAL_SUCCESS,
  DELETE_MATERIAL_FAIL,
  CLEAN_MATERIAL,
  SAVE_MASSIVE_CHARGE,
  SAVE_MASSIVE_CHARGE_ERROR,
  SAVE_MASSIVE_CHARGE_SUCCESS,
} from "./actionTypes"

const INIT_STATE = {
  materialList: [],
  types: [],
  error: "",
  areaList: [],
  fileTypeList: [],
  loading: false,
  loadingSave: false,
  response: null,
  responseDelete: null,
  errorResponseList: null,
}

const materialSupplier = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_MATERIAL:
      return {
        ...state,
        materialList: [],
        loading: true,
        response: null,
      }
    case GET_MATERIAL_SUCCESS:
      return {
        ...state,
        materialList: action.payload.data,
        loading: false,
      }

    case GET_MATERIAL_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
        response: null,
      }
    case SAVE_MATERIAL:
      return {
        ...state,
        loading: true,
        loadingSave: true,
        response: null,
      }
    case SAVE_MATERIAL_SUCCESS:
      return {
        ...state,
        loadingSave: false,
        loading: false,
        error: "",
        response: action.payload.data,
      }
    case SAVE_MATERIAL_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
        response: null,
        loadingSave: false,
      }
    case UPDATE_MATERIAL:
      return {
        ...state,
        loading: true,
        loadingSave: true,
        response: null,
      }
    case UPDATE_MATERIAL_SUCCESS:
      return {
        ...state,
        loadingSave: false,
        loading: false,
        error: "",
        response: action.payload.data,
      }
    case UPDATE_MATERIAL_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
        response: null,
        loadingSave: false,
      }

    case DELETE_MATERIAL_SUCCESS:
      return {
        ...state,
        response: action.payload.data,
        loading: false,
        responseDelete: action.payload.data,
      }
    case DELETE_MATERIAL:
      return {
        ...state,
        response: null,
        loading: true,
        responseDelete: null,
      }
    case DELETE_MATERIAL_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
        response: null,
        loadingSave: false,
      }
    case CLEAN_MATERIAL:
      return {
        ...state,
        error: null,
        loading: false,
        response: null,
        loadingSave: false,
        responseDelete: null,
        errorResponseList: null,
      }
    case SAVE_MASSIVE_CHARGE:
      return { ...state, loading: true }
    case SAVE_MASSIVE_CHARGE_ERROR:
      return {
        ...state,
        errorResponseList: action.payload.data,
        loading: false,
      }
    case SAVE_MASSIVE_CHARGE_SUCCESS:
      return {
        ...state,
        errorResponseList: action.payload.data,
        loading: false,
      }
    default:
      return state
  }
}

export default materialSupplier
